"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../api");
var awsIndex_1 = require("../api/awsIndex");
var CareerSiteHeaderFooterDataProvider_1 = require("player-career-site-header-footer/shared/provider/CareerSiteHeaderFooterDataProvider");
var apiServices = new api_1.ApiServices();
var awsApiServices = new awsIndex_1.AwsApiServices();
var headerFooterDataProvider = new CareerSiteHeaderFooterDataProvider_1.CareerSiteHeaderFooterDataProvider();
var siteData = {
    header: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: ''
    },
    footer: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: ''
    },
    settings: {
        allowedLanguages: [],
        signInPath: "",
        signOutPath: "",
        createProfilePath: "",
        myProfilePath: "",
        showToolbar: true,
        currentLanguage: {
            cultureId: 1,
            cultureName: "en-US",
            isRightToLeft: false
        },
        mapsApiKey: "",
        mapsIsPremium: false,
        allowSEO: false,
        jobPostingSEOLogoPath: "",
        isJobAlertsEnabled: false
    },
    searchBanner: {
        bannerImagePath: [],
        bannerHtml: ""
    },
    companyInformationHtml: "",
    jobDetailsBannerImagePath: ""
};
var jobDetail = {
    displayTitle: "",
    externalDescription: "",
    ref: "",
    jobAd: "",
    primaryLocation: {
        title: "",
        locationDisplayTitle: "",
        geocode: {
            latitude: "",
            longitude: ""
        },
        city: "",
        state: "",
        country: "",
        postalCode: "",
        line1: ""
    },
    additionalLocations: new Array()
};
var searchResults = {
    results: new Array(),
    totalSearchResults: 0,
    filters: new Array(),
    customFieldFilters: new Array()
};
exports.bootstrap = function (careerSiteId, cultureId) {
    return apiServices.getCareerSiteData(careerSiteId, cultureId)
        .then(function (data) {
        siteData = Object.assign(siteData, headerFooterDataProvider.mapHeaderFooterFromCareerSite(data.data));
        return Promise.resolve();
    });
};
exports.bootstrapApplication = function (careerSiteId, reqId, cultureId) {
    return Promise.all([
        apiServices.getCareerSiteData(careerSiteId, cultureId),
        apiServices.getJobDetail(careerSiteId, reqId, cultureId)
    ]).then(function (data) {
        siteData = Object.assign(siteData, headerFooterDataProvider.mapHeaderFooterFromCareerSite(data[0].data));
        jobDetail = Object.assign(jobDetail, data[1]);
        return Promise.resolve();
    });
};
exports.buildSearchRequest = function (careerSiteId, pageNumber, pageSize, searchText, states, countryCodes, cities, language, placeID, radius, postingsWithinDays, customFieldCheckboxKeys, customFieldDropdowns, customFieldRadios) {
    return {
        careerSiteId: careerSiteId,
        careerSitePageId: careerSiteId,
        pageNumber: pageNumber,
        pageSize: pageSize,
        cultureId: language.cultureId,
        searchText: searchText,
        cultureName: language.cultureName,
        states: states,
        countryCodes: countryCodes,
        cities: cities,
        placeID: placeID,
        radius: radius,
        postingsWithinDays: postingsWithinDays,
        customFieldCheckboxKeys: customFieldCheckboxKeys,
        customFieldDropdowns: customFieldDropdowns,
        customFieldRadios: customFieldRadios
    };
};
exports.buildJobAlertRequest = function (cadence, name, careerSitePageId, searchText, states, countryCodes, cities, language, placeID, radius, postingsWithinDays, customFieldCheckboxKeys, customFieldDropdowns, customFieldRadios, careerSiteSearchUrl) {
    var externalFilters = {
        cultureId: language.cultureId,
        searchText: searchText,
        radius: radius,
        countryCodes: countryCodes,
        states: states,
        cities: cities,
        placeID: placeID,
        postingsWithinDays: postingsWithinDays,
        customFieldCheckboxKeys: customFieldCheckboxKeys,
        customFieldDropdowns: customFieldDropdowns,
        customFieldRadios: customFieldRadios
    };
    return {
        cadence: cadence,
        name: name,
        careerSitePageId: careerSitePageId,
        externalFilters: Object.assign(externalFilters),
        careerSiteSearchURL: careerSiteSearchUrl
    };
};
exports.getCustomFields = function (fieldIds) {
    return apiServices.getCustomFields(fieldIds);
};
exports.getSiteData = function () {
    return Promise.resolve(siteData);
};
exports.getJobDetail = function (careerSiteId, reqId, cultureId) {
    return apiServices.getJobDetail(careerSiteId, reqId, cultureId);
};
exports.getJobAd = function (careerSiteId, reqId, cultureId) {
    return apiServices.getJobAd(careerSiteId, reqId, cultureId);
};
exports.getJobPosting = function (careerSiteId, reqId) {
    return apiServices.getJobPosting(careerSiteId, reqId);
};
exports.getCorpSettingValue = function (key) {
    return apiServices.getCorpSettingValue(key);
};
exports.getOuTitle = function (ouId) {
    return apiServices.getOuTitle(ouId);
};
exports.getOuLocations = function () {
    return Promise.resolve(apiServices.getOuLocations());
};
exports.getInitialJobResults = function () {
    return Promise.resolve(searchResults);
};
exports.getNewJobResults = function (searchData) {
    return awsApiServices.getNewResults(searchData).then(function (data) {
        return data;
    });
};
exports.getLocationSearch = function (query, google) {
    return new Promise(function (resolve) {
        apiServices.locationSearch(query, google).then(function (data) {
            var results = {
                results: new Array()
            };
            resolve(Object.assign(results, data));
        });
    });
};
exports.getApplicationWorkflowUrl = function (jobRequisitionId, careerSiteId) {
    return new Promise(function (resolve) {
        apiServices.getApplicationWorkflowUrl(jobRequisitionId, careerSiteId).then(function (data) {
            resolve(data.data[0]);
        });
    });
};
exports.getApplicantApplyStatus = function (careerSiteId, jobRequisitionId) {
    return apiServices.getApplicantApplyStatus(careerSiteId, jobRequisitionId);
};
exports.getKeywordPredictiveSearchResults = function (searchRequest) {
    return awsApiServices.getKeywordPredictiveSearchResults(searchRequest).then(function (data) {
        return data.data;
    });
};
exports.saveJob = function (jobRequisitionId) {
    return apiServices.saveJobForUser(jobRequisitionId);
};
exports.saveJobAlert = function (jobAlertRequest) {
    return apiServices.saveJobAlert(jobAlertRequest);
};
exports.getSavedJob = function (jobRequisitionId) {
    return apiServices.getSavedJobForUser(jobRequisitionId);
};
exports.getUserEmail = function () {
    return apiServices.getUserEmail();
};



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/mapping/index.ts
// module id = 96
// module chunks = 0